export type DesignType = 'NONE' | 'HAVE';

// 주문하기 하위 메뉴 (Header 메뉴와 진입 화면 카드에 같은 구성으로 사용)
export const ORDER_MENU: { designType: DesignType; label: string; to: string; desc: string }[] = [
  {
    designType: 'NONE',
    label: '디자인 없음',
    to: '/portfolio',
    desc: '디자인 파일이 없어도 괜찮습니다. 원하는 상품을 고르시면 G-WORKS가 디자인 시안부터 제작·배송까지 진행합니다.',
  },
  {
    designType: 'HAVE',
    label: '디자인 있음',
    to: '/order/print',
    desc: '인쇄용 디자인 파일을 가지고 계신가요? 용지·사이즈·수량 등 옵션을 고르고 실시간 가격을 확인한 뒤 바로 주문하세요.',
  },
];

export const DESIGN_TYPE_LABEL: Record<DesignType, string> = {
  NONE: '디자인 없음 (G-WORKS 디자인)',
  HAVE: '디자인 있음 (인쇄 파일 보유)',
};
